import { Grid } from "@mui/material";
import InputGroup from "../../../components/FormComponent/InputGroup";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Button from "../../../components/Button/Button";
import styles from "../settings.module.css";
import { toast, ToastContainer } from "react-toastify";
import { useState } from "react";
import { httprequest } from "../../../data/api";
import { Icon } from "@iconify/react";

const Password = () => {
  const PASSWORD_CHANGE = "/admin/v1/auth/change-password";
  const [passwords, setPasswords] = useState({
    old_password: "",
    new_password: "",
    confirm_password: ""
  });
  const [passwordType, setPasswordType] = useState("password");
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    setPasswords({ ...passwords, [e.target.name]: e.target.value });
  };

  const validatePasswords = () => {
    if (!passwords.old_password || !passwords.new_password || !passwords.confirm_password) {
      toast.error("All fields are required.");

      return false;
    }
    if (passwords.new_password !== passwords.confirm_password) {
      toast.error("New passwords do not match.");

      return false;
    }

    return true;
  };

  const handleCreatePlan = () => {
    if (validatePasswords()) {
      setIsLoading(true);
      httprequest
        .patch(PASSWORD_CHANGE, {
          old_password: passwords.old_password,
          new_password: passwords.new_password
        })
        .then((res) => {
          setIsLoading(false);
          toast.success(res?.data?.message || "Password updated successfully");
        })
        .catch((err) => {
          setIsLoading(false);
          toast.error(err?.response?.data?.message || "Error updating password");
        });
    }
  };
  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
    } else {
      setPasswordType("password");
    }
  };

  return (
    <div>
      <div className="text-align">
        <h4 className={`${styles.changepassword}`}>Change Password</h4>
        <p className={`${styles.passwordtext}`}>Change the password for better security to this application.</p>
      </div>
      <Grid className="input-padding" container lg={6} md={6} sm={6} xs={12}
        spacing={2}
      >
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <InputGroup
            label="Current Password"
            margin="normal"
            placeHolder="***********"
            inputType={passwordType}
            inputName="old_password"
            value={passwords.old_password}
            onChange={handleInputChange}
          />
          <div className="password-eye">
            {passwordType === "password" ? (
              <Icon icon="fluent:eye-16-regular" color="black" onClick={togglePassword} />
            ) : (
              <Icon icon="iconamoon:eye-off-light" color="black" onClick={togglePassword} />
            )}
          </div>
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <InputGroup
            label="New Password"
            margin="normal"
            placeHolder="***********"
            inputType={passwordType}
            inputName="new_password"
            value={passwords.new_password}
            onChange={handleInputChange}
          />
          <div className="password-eye">
            {passwordType === "password" ? (
              <Icon icon="fluent:eye-16-regular" color="black" onClick={togglePassword} />
            ) : (
              <Icon icon="iconamoon:eye-off-light" color="black" onClick={togglePassword} />
            )}
          </div>
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <InputGroup
            label="Confirm New Password"
            margin="normal"
            placeHolder="***********"
            inputType={passwordType}
            inputName="confirm_password"
            value={passwords.confirm_password}
            onChange={handleInputChange}
          />
          <div className="password-eye">
            {passwordType === "password" ? (
              <Icon icon="fluent:eye-16-regular" color="black" onClick={togglePassword} />
            ) : (
              <Icon icon="iconamoon:eye-off-light" color="black" onClick={togglePassword} />
            )}
          </div>
        </Grid>
      </Grid>
      <div className="input-padding">
        <Button
          variant="primary"
          buttonSize="fluid"
          color="btndefault"
          buttonName={
            <div className="flex align-items-center gap-5">
              <AddCircleOutlineIcon />
              {isLoading ? "Updating..." : "Update Password"}
            </div>
          }
          disabled={isLoading}
          onClick={handleCreatePlan}
        />
      </div>
      <ToastContainer />
    </div>
  );
};

export default Password;
